import { render, staticRenderFns } from "./parts1.vue?vue&type=template&id=1492e1d1&scoped=true&"
import script from "./parts1.vue?vue&type=script&lang=ts&"
export * from "./parts1.vue?vue&type=script&lang=ts&"
import style0 from "./parts1.vue?vue&type=style&index=0&id=1492e1d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1492e1d1",
  null
  
)

export default component.exports